// Always use the dark theme across the site.
export function applyAutoDarkMode() {
  try {
    const html = document.documentElement
    html.classList.add('dark')
  } catch {
    // Fail silently
  }
}